// Filters the master categories list to those relevant for a given transaction type.
// income/revenue → cash-in categories only. expense/recurring → spending only. borrow/lend → financial only.
const INCOME_ALLOWED = new Set(["income", "investments", "transfers", "charity_religious", "other"]);
const LOAN_ALLOWED = new Set(["loans_installments", "transfers", "other"]);
const EXPENSE_HIDDEN = new Set(["income"]); // never a spend category

export function filterCategoriesByType(cats, txType) {
  if (!Array.isArray(cats)) return [];
  if (txType === "income" || txType === "revenue") {
    return cats.filter((c) => INCOME_ALLOWED.has(c.id));
  }
  if (txType === "borrow" || txType === "lend" || txType === "repay_borrow" || txType === "repay_lend") {
    return cats.filter((c) => LOAN_ALLOWED.has(c.id));
  }
  // expense / recurring / default
  return cats.filter((c) => !EXPENSE_HIDDEN.has(c.id));
}
